import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { RoleService } from '@common/services/role.service';
import { UserService } from '@common/services/user.service';
import { CommonService } from '../../../singleton-services/common.service';

const noop = function (item) {
    if (item.code) return `${item.code} - ${item.name}`;
    if (item.id) return `${item.id} - ${item.name}`;
};
@Component({
    selector: 'dropdown-add',
    templateUrl: './dropdown-add.component.html',
    styleUrls: ['./dropdown-add.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DropdownAddComponent implements OnInit {
    @Input() allowDuplicates?: boolean;
    @Output() eventTriggered = new EventEmitter<object>();
    @ViewChild('selectedElement', { static: false }) selectedElement: any;
    @Input() displayProperty?: string = 'name';
    @Input() codeListValues: any = [];
    @Input() floatingLabelText: string;
    @Input() codeListName: string;
    @Input() selectLabel = noop;
    @Input() disabled = false;
    @Input() multi: boolean = false;

    @Input() includeExpirationDate = false;

    selectedDate = null;

    untouchedData: any = [];
    data: any = [];

    public selectedValue: any = null;
    public selectedValues: any[] = [];

    constructor(
        private commonService: CommonService,
        private userService: UserService,
        private roleService: RoleService
    ) {}

    ngOnInit() {
        if (this.codeListName) {
            switch (this.codeListName) {
                case 'Role': {
                    this.userService.getRoles().subscribe((data) => {
                        if (data) {
                            this.untouchedData = data;
                            this.data = data.slice();
                        }
                    });
                    break;
                }
                case 'Organization': {
                    this.userService.getOrganizations().subscribe((data) => {
                        if (data) {
                            this.untouchedData = data;
                            this.data = data.slice();
                        }
                    });
                    break;
                }
                case 'User': {
                    this.userService.getUsers().subscribe((data) => {
                        if (data) {
                            this.untouchedData = data;
                            this.data = data.slice();
                        }
                    });
                    break;
                }
                case 'Permission': {
                    this.roleService.getPermissions().subscribe((data) => {
                        if (data) {
                            this.untouchedData = data;
                            this.data = data.slice();
                        }
                    });
                    break;
                }
                default: {
                    this.commonService.getDropdownOptions(this.codeListName).subscribe((data) => {
                        if (data == null) return;
                        data = data.map((x: any) => ({
                            label: this.selectLabel(x),
                            id: x.id,
                            name: x.name
                        }));

                        this.untouchedData = data;
                        this.data = data.slice();
                    });
                    break;
                }
            }
        } else if (this.codeListValues) {
            this.setData(this.codeListValues);
        } else {
            throw new Error('Either codeListName or codeListValue expected to be passed into the dropdown component.');
        }
    }

    handleFilter(value) {
        this.data = this.untouchedData.filter(
            (s) => s[this.displayProperty].toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
    }

    addElement() {
        if (this.multi) {
            const selected = this.selectedValues || [];
            const selectedArray = Array.isArray(selected) ? selected : [selected];
            if (selectedArray.length === 0) return;

            const ids = selectedArray.map((x) => (x && x.id != null ? x.id : x));

            let payloadValues: any = ids;
            if (this.includeExpirationDate) {
                payloadValues = selectedArray.map((x) => ({
                    id: x && x.id ? x.id : x,
                    expirationDate: this.selectedDate
                }));
            }

            const element = {
                dropdownValue: payloadValues,
                allowDuplicates: this.allowDuplicates,
                multi: true
            };
            this.eventTriggered.emit(element);

            this.selectedValues = [];
            if (this.selectedElement) {
                this.selectedElement.value = [];
            }

            if (!this.allowDuplicates) {
                const idsToRemove = ids;
                this.untouchedData = this.untouchedData.filter((item) => !idsToRemove.includes(item.id));
                this.data = this.data.filter((item) => !idsToRemove.includes(item.id));
            }
        } else {
            const id = this.selectedValue;
            if (id == null) return;
            let item = this.untouchedData?.find((x) => x.id == id);

            if (!item) return;

            if (this.includeExpirationDate) {
                item = { ...item, expirationDate: this.selectedDate };
            }
            const element = {
                dropdownValue: item,
                allowDuplicates: this.allowDuplicates,
                multi: false
            };
            this.eventTriggered.emit(element);

            this.selectedValue = null;
            if (this.selectedElement) {
                this.selectedElement.value = null;
            }

            if (!this.allowDuplicates) {
                this.untouchedData = this.untouchedData.filter((it) => it.id !== item.id);
                this.data = this.data.filter((it) => it.id !== item.id);
            }
        }
        this.selectedDate = null;
    }

    setData(value: any) {
        this.data = value;
        this.untouchedData = value;
        this.selectedValues = [];
        this.selectedValue = null;
    }

    public changeExpirationDateEvent($event) {
        this.selectedDate = $event;
    }
}
